import React from 'react';
import { CalendarIcon, MapPinIcon, UsersIcon } from 'lucide-react';
import { Card, CardContent, CardHeader } from './Card';
interface EventCardProps {
  id: string;
  title: string;
  date: string;
  location: string;
  imageUrl: string;
  availableTables: number;
  onClick: () => void;
}
export const EventCard = ({
  id,
  title,
  date,
  location,
  imageUrl,
  availableTables,
  onClick
}: EventCardProps) => {
  return <Card variant="outlined" isClickable onClick={onClick} className="mb-4" data-id="element-38">
      <CardContent mediaUrl={imageUrl} mediaAspectRatio="16:9" data-id="element-39">
        <div className="p-4" data-id="element-40">
          <h3 className="text-lg font-medium text-gray-800" data-id="element-41">{title}</h3>
          <div className="flex items-center mt-2 text-gray-600" data-id="element-42">
            <CalendarIcon className="h-4 w-4 mr-1" data-id="element-43" />
            <span className="text-sm" data-id="element-44">{date}</span>
          </div>
          <div className="flex items-center mt-1 text-gray-600" data-id="element-45">
            <MapPinIcon className="h-4 w-4 mr-1" data-id="element-46" />
            <span className="text-sm" data-id="element-47">{location}</span>
          </div>
          <div className="flex items-center mt-1 text-gray-600" data-id="element-48">
            <UsersIcon className="h-4 w-4 mr-1" data-id="element-49" />
            <span className="text-sm" data-id="element-50">{availableTables} tables available</span>
          </div>
        </div>
      </CardContent>
    </Card>;
};